
(function(){
  'use strict';
  function startKtryDemo(){
    var root=document.querySelector('[data-ktry-demo-toast]');
    if(!root || root.dataset.initialized==='true')return;
    root.dataset.initialized='true';
    var image=root.querySelector('[data-ktry-demo-image]');
    var nameEl=root.querySelector('[data-ktry-demo-name]');
    var productEl=root.querySelector('[data-ktry-demo-product]');
    var locationEl=root.querySelector('[data-ktry-demo-location]');
    var timeEl=root.querySelector('[data-ktry-demo-time]');
    var counterEl=root.querySelector('[data-ktry-demo-counter]');
    var pauseButton=root.querySelector('[data-ktry-demo-pause]');
    var closeButton=root.querySelector('[data-ktry-demo-close]');
    if(!image||!nameEl||!productEl||!locationEl||!timeEl||!counterEl)return;
    // These seven images are from the KTRY product previews, not order records.
    var products=[
      {title:'Maldives Tropical Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-maldives-maroon-front-supplier.png?v=1793743207'},
      {title:'Switzerland Alpine Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-switzerland-pink-front-supplier.png?v=1793743092'},
      {title:'Los Angeles Sunset Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-los-angeles-gray-front-supplier.png?v=1793743035'},
      {title:'London Landmarks Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-london-white-front-supplier.png?v=1793742999'},
      {title:'New York Liberty Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-new-york-black-front-supplier.png?v=1793742942'},
      {title:'Istanbul Skyline Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-istanbul-front-supplier.png?v=1793742871'},
      {title:'Switzerland Scenic Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-switzerland-white-front-supplier.png?v=1793742906'},
      {title:'Los Angeles Navy Heather Hoodie',image:'https://cdn.shopify.com/s/files/1/0840/6355/1639/files/ktry-los-angeles-navy-front-supplier.png?v=1793743141'}
    ];
    // Fictional example names/cities: 50 distinct sample entries, not actual customer data.
    var customers=[
      ['Ayesha','Lahore'],['Hamza','Karachi'],['Hira','Islamabad'],['Bilal','Multan'],['Zara','Faisalabad'],
      ['Usman','Rawalpindi'],['Mariam','Gujranwala'],['Ali','Peshawar'],['Sana','Sialkot'],['Ahmed','Hyderabad'],
      ['Fatima','Lahore'],['Hassan','Karachi'],['Noor','Islamabad'],['Omer','Multan'],['Iqra','Faisalabad'],
      ['Danish','Rawalpindi'],['Mahnoor','Gujranwala'],['Saad','Peshawar'],['Rida','Sialkot'],['Arham','Hyderabad'],
      ['Amna','Lahore'],['Fahad','Karachi'],['Laiba','Islamabad'],['Taha','Multan'],['Anum','Faisalabad'],
      ['Zain','Rawalpindi'],['Areeba','Gujranwala'],['Rayyan','Peshawar'],['Eman','Sialkot'],['Shahzaib','Hyderabad'],
      ['Kiran','Lahore'],['Junaid','Karachi'],['Mehak','Islamabad'],['Talha','Multan'],['Hafsa','Faisalabad'],
      ['Rafay','Rawalpindi'],['Alina','Gujranwala'],['Adeel','Peshawar'],['Saba','Sialkot'],['Muneeb','Hyderabad'],
      ['Nimra','Lahore'],['Farhan','Karachi'],['Aiman','Islamabad'],['Waleed','Multan'],['Sara','Faisalabad'],
      ['Shayan','Rawalpindi'],['Zoya','Gujranwala'],['Huzaifa','Peshawar'],['Sehrish','Sialkot'],['Sameer','Hyderabad']
    ];
    var timer=null, index=0, closed=false, paused=false, hovering=false, focusInside=false;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function update(entryIndex){
      var customer=customers[entryIndex];
      var product=products[entryIndex%products.length];
      // Fictional elapsed time for demonstration only; not generated from any purchase.
      var minutes=3+((entryIndex*17)%176);
      image.src=product.image;
      image.alt=product.title+' product preview image';
      nameEl.textContent=customer[0];
      productEl.textContent=product.title;
      locationEl.textContent=customer[1]+', Pakistan';
      timeEl.textContent=(minutes>=60?Math.floor(minutes/60)+'h '+(minutes%60)+'m':minutes+'m')+' ago';
      counterEl.textContent=String(entryIndex+1).padStart(2,'0')+' / 50';
    }
    function clear(){if(timer!==null){window.clearTimeout(timer);timer=null;}}
    function shouldWait(){return closed||paused||hovering||focusInside||document.hidden;}
    function schedule(action,delay){clear();if(!closed)timer=window.setTimeout(action,delay);}
    function showNext(){
      if(closed)return;
      if(shouldWait()){schedule(showNext,1400);return;}
      update(index);
      root.hidden=false;
      requestAnimationFrame(function(){if(!closed)root.classList.add('is-visible');});
      index=(index+1)%customers.length;
      if(!reduced)schedule(hideCurrent,6100);
    }
    function hideCurrent(){
      if(closed)return;
      if(shouldWait()){schedule(hideCurrent,1200);return;}
      root.classList.remove('is-visible');
      schedule(function(){root.hidden=true;showNext();},2300);
    }
    function close(){
      closed=true;clear();root.classList.remove('is-visible');root.hidden=true;
      try{window.sessionStorage.setItem('ktry_demo_toast_dismissed','yes');}catch(e){}
    }
    closeButton&&closeButton.addEventListener('click',close);
    pauseButton&&pauseButton.addEventListener('click',function(){
      paused=!paused;
      pauseButton.setAttribute('aria-label',paused?'Resume demo notifications':'Pause demo notifications');
      pauseButton.setAttribute('title',paused?'Resume demo notifications':'Pause demo notifications');
      pauseButton.innerHTML=paused?'<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true"><path d="M7 4v16l13-8z"></path></svg>':'<svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="5" y="4" width="4" height="16" rx="1"></rect><rect x="15" y="4" width="4" height="16" rx="1"></rect></svg>';
      if(!paused&&!closed){schedule(hideCurrent,6100);}
    });
    root.addEventListener('mouseenter',function(){hovering=true;});
    root.addEventListener('mouseleave',function(){hovering=false;});
    root.addEventListener('focusin',function(){focusInside=true;});
    root.addEventListener('focusout',function(e){if(!root.contains(e.relatedTarget))focusInside=false;});
    try{if(window.sessionStorage.getItem('ktry_demo_toast_dismissed')==='yes')return;}catch(e){}
    schedule(showNext,5200);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',startKtryDemo);}
  else{startKtryDemo();}
})();
